<template>
  <ButtonSecondary
    data-test-id="HeaderItemPricing__pricingButton"
    :text="pricingButtonText"
    @click="openPricingPage"
  />
</template>

<script>
import { ButtonSecondary } from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import { eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import Util from 'client/util/Util';

const {
  text,
  toUrl,
} = eventProperties;

export default {
  name: 'HeaderItemPricing',

  Util,

  components: {
    ButtonSecondary,
  },

  computed: {
    pricingButtonText() {
      return 'Pricing';
    },

    pricingLink() {
      return ItemTypeRoutes[ItemTypeConsts.pricing];
    },
  },

  methods: {
    emitClickEvent() {
      this.$emit('click', {
        [text]: this.pricingButtonText,
        [toUrl]: this.pricingLink,
      });
    },

    openPricingPage() {
      this.$options.Util.redirect(this.pricingLink);
      this.emitClickEvent();
    },
  },
};
</script>
